import PropTypes from 'prop-types';

export const apiServiceShape = PropTypes.shape({
  'get': PropTypes.func.isRequired,
  'post': PropTypes.func.isRequired
});



// WEBPACK FOOTER //
// ./src/client/helpers/shapes.js